var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
/* eslint-disable react/display-name */
// Array to store React contexts
var contexts = [];
// Use specific context
export function useContext(Context) {
    contexts.push(Context);
}
// Clear contexts in use
export function clearContexts() {
    contexts.length = 0;
}
// Shim `React.createContext()` to capture contexts
var shimmed = false;
export function shim() {
    if (shimmed)
        return;
    shimmed = true;
    var createContext = React.createContext;
    React.createContext = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var Context = createContext.apply.apply(createContext, __spreadArray([this], args, false));
        contexts.push(Context);
        return Context;
    };
}
// Create Provider component for specific context types
export function _makeProvider(contextTypes) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(ProvideContext, _super);
            function ProvideContext() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            ProvideContext.prototype.getChildContext = function () {
                return this.props.context;
            };
            ProvideContext.prototype.render = function () {
                return this.props.children;
            };
            return ProvideContext;
        }(Component)),
        _a.childContextTypes = contextTypes,
        _a;
}
// Server-side render, propagating contexts to children
export function _render(self) {
    var element = self.props.children;
    try {
        var content = String(renderToStaticMarkup(element));
        if (content.indexOf('&lt;'))
            return '';
        return content;
    }
    catch (e) {
        return self.props.fallBack();
    }
}
//# sourceMappingURL=server.js.map